import React from 'react';
import { FormGroup, FormControl, HelpBlock } from 'react-bootstrap';
import { translate } from 'react-i18next';

// function getErrorMessage(touched, errorMessage) {
//   const style = {
//     color: 'red',
//     position: 'absolute',
//     bottom: '-18px',
//     left: 0,
//     margin: 0
//   };
//
//   // eslint-disable-next-line jsx-a11y/label-has-associated-control
//   return touched && errorMessage ? <label style={style}>{errorMessage}</label> : '';
// }

export default translate(['ui'])(({ placeholder, type, t, meta: { touched, error }, input }) => {
  const hasError = touched && error;

  return (
    <FormGroup validationState={hasError ? 'error' : null}>
      {/* eslint-disable-next-line react/jsx-props-no-spreading */}
      <FormControl {...input} type={type} placeholder={placeholder} />
      {hasError ? <HelpBlock>{t(error)}</HelpBlock> : null}
    </FormGroup>
  );
});



// WEBPACK FOOTER //
// ./components/SecurityBoxInput.jsx